<ng-template #routesList let-extraClasses="extraClasses">
  <div class="suggested-routes g-large" [ngClass]="extraClasses">
    @for (group of groups(); track group.originLocationCode) {
      <div class="flex flex--column flex--align-start g-small">
        <h3 class="mr-clear font-heading-5 nordic-blue-900-text text-icon-primary font-title-small">
          {{ 'ondMarketing.flightsFrom' | finLocalization: { origin: group.originCityName } }}
        </h3>

        @for (link of group.links; track link.href) {
          <fcom-link
            [href]="link.disabled ? undefined : link.href"
            [disabled]="link.disabled"
            [icon]="{
              position: IconPosition.RIGHT,
              name: link.disabled ? SvgLibraryIcon.CHECKMARK_BUTTON_SELECTED : SvgLibraryIcon.ARROW_RIGHT,
              extraClasses: link.disabled ? 'success-900-text signal-success-notification-border-icon-text' : undefined,
            }"
          >
            {{ link.originCityName }}–{{ link.destinationCityName }}
          </fcom-link>
        }
      </div>
    }
  </div>
</ng-template>

@if (type() === OndCrossLinkingType.CITY_TO_CITY_LANDING) {
  <h1 class="flex flex--middle mr-medium-b font-heading-3 nordic-blue-900-text text-icon-primary font-headline-medium">
    <fcom-icon class="icon-large ms-small-r" [name]="SvgLibraryIcon.CONNECTING_FLIGHT" />
    <span>{{ 'ondMarketing.heading.cityToCity' | finLocalization }}</span>
  </h1>
  @if (loading()) {
    <fcom-loader class="ms-xxlarge-y" [loaderType]="LoaderTheme.EMBEDDED" data-testid="suggested-routes-loader" />
  } @else if (groups().length) {
    <ng-container [ngTemplateOutlet]="routesList" [ngTemplateOutletContext]="{ extraClasses: '' }" />
  }
}

@if (type() === OndCrossLinkingType.CITY_TO_CITY) {
  <h2 class="flex flex--middle mr-small-b font-heading-3 nordic-blue-900-text text-icon-primary font-headline-small">
    <fcom-icon class="icon-large ms-small-r" [name]="SvgLibraryIcon.CONNECTING_FLIGHT" />
    <span>{{ 'ondMarketing.heading.cityToCity' | finLocalization }}</span>
  </h2>
  @if (loading()) {
    <fcom-loader class="ms-small-y" [loaderType]="LoaderTheme.EMBEDDED" data-testid="suggested-routes-loader" />
  } @else if (groups().length) {
    <ng-container [ngTemplateOutlet]="routesList" [ngTemplateOutletContext]="{ extraClasses: 'ms-large-b' }" />
  }
}
